module.exports = __webpack_public_path__ + "img/logo-paposlandia-by-zapateria-letty.8d45d9bb.png";